import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import { ReactComponent as Logout } from "../../assets/icons/sidebar/logout.svg";
import { useUserContext } from "../../context/useUserContext";
import { useNavigate } from "react-router-dom";
import { showGenericError } from "../../helper/Notifications";

const UserProfileCard = () => {
  const { user, logoutUser } = useUserContext();
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser(
      (response) => {
        navigate("/login");
      },
      () => {
        showGenericError();
      }
    );
  };

  const handleProfileClick = () => {
    navigate("/profile");
  };

  // Create initials from user name or email
  const getInitials = () => {
    if (user?.name) {
      return user.name
        .split(" ")
        .map(name => name[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
    }
    if (user?.email) {
      return user.email.slice(0, 2).toUpperCase();
    }
    return "U";
  };

  const getUserName = () => {
    return user?.name || "User";
  };

  const getUserEmail = () => {
    return user?.email || "user@example.com";
  };

  return (
    <Container>
      <UserInfo onClick={handleProfileClick}>
        <Avatar>
          <span>{getInitials()}</span>
        </Avatar>
        <UserDetails>
          <UserName>{getUserName()}</UserName>
          <UserEmail>{getUserEmail()}</UserEmail>
        </UserDetails>
      </UserInfo>
      <LogoutButton onClick={handleLogout}>
        <Logout />
      </LogoutButton>
    </Container>
  );
};

export default UserProfileCard;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 12px;
  margin: 0 4px 16px 4px;
  background: ${lightThemeColors.background};
  border: 1px solid ${lightThemeColors.sidebar.menuItemBorder};
  border-radius: 8px;
  transition: all 200ms ease;

  &:hover {
    background: ${lightThemeColors.menuBackground};
  }

  @media (max-width: 768px) {
    padding: 16px 12px;
    margin: 0 4px 16px 4px;
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
`;

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${lightThemeColors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  span {
    color: white;
    font-size: 14px;
    font-weight: 600;
  }
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

const UserName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${lightThemeColors.darkColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const UserEmail = styled.span`
  font-size: 12px;
  color: ${lightThemeColors.darkColor50};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  flex-shrink: 0;

  svg {
    width: 16px;
    height: 16px;
    color: ${lightThemeColors.darkColor50};
  }
`;